import styled, { css } from 'styled-components';

interface ButtonTabsProps {
  isFocused: boolean;
}

export const ButtonTabs = styled.button<ButtonTabsProps>`
  border: none;
  padding: 5px;
  background-color: #fff;
  color: #1976d2;
  ${(props) =>
    props.isFocused &&
    css`
      background-color: #1976d2;
      color: #fff;
    `}
`;
